"use client"
import React, { useState, useEffect } from "react"
import {
  usableNetAssistive,
  useableNetAssistiveActive,
} from "./UsableNetButton.css"
import { useSegment } from "tracking"

export const UsableNetButton = () => {
  const [isAccessibilityEnabled, setIsAccessibilityEnabled] = useState(false)
  const { track } = useSegment()

  useEffect(() => {
    const getCookieValue = (name) => {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      )
      return match ? match[2] : null
    }

    const cookieValue = getCookieValue("UsableNetAssistive")
    if (cookieValue === "1") {
      setIsAccessibilityEnabled(true)
    }
  }, [])

  const accessibilityToggleText = isAccessibilityEnabled
    ? "Exit Accessibility Mode"
    : "Enable Accessibility"

  const handleClick = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        location_type: "HEADER",
        module_content: "Accessibility Mode Button",
        module_content_details: accessibilityToggleText,
      },
    })

    if (isAccessibilityEnabled) {
      // Call the function to disable accessibility mode
      if (window.disableUsableNetAssistive) {
        window.disableUsableNetAssistive()
      }
    } else {
      // Call the function to enable accessibility mode
      if (window.enableUsableNetAssistive) {
        window.enableUsableNetAssistive()
      }
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href="#"
      className={
        isAccessibilityEnabled ? useableNetAssistiveActive : usableNetAssistive
      }
      onClick={handleClick}
    >
      {accessibilityToggleText}
    </a>
  )
}
